import * as React from 'react';
import { useState } from 'react';
import { GitHubButton } from '../github-button';
import { SLACK_INVITE_LINK } from '../../constants';

export const MainMenu = () => {
	const [isExpanded, setIsExpanded] = useState(false);

	const menuItems = (
		<>
			<li>
				<a
					pirsch-event="menu-demo"
					href="https://demo.graphweaver.com"
					target="_blank"
					rel="noopener noreferrer"
				>
					Demo
				</a>
			</li>
			<li>
				<a
					pirsch-event="menu-docs"
					href="https://graphweaver.com/docs"
					target="_blank"
					rel="noopener noreferrer"
				>
					Docs
				</a>
			</li>
			<li>
				<a
					pirsch-event="menu-github"
					href="https://github.com/exogee-technology/graphweaver"
					target="_blank"
					rel="noopener noreferrer"
				>
					GitHub
				</a>
			</li>
			<li>
				<a
					pirsch-event="menu-slack"
					href={SLACK_INVITE_LINK}
					target="_blank"
					rel="noopener noreferrer"
				>
					Need help?
				</a>
			</li>
			<li>
				<a
					pirsch-event="menu-get-started"
					className="get-started-btn"
					href="https://graphweaver.com/docs/quick-start"
					target="_blank"
					rel="noopener noreferrer"
				>
					Get started <span></span>
				</a>
			</li>
			<li>
				<GitHubButton />
			</li>
		</>
	);

	const toggleMenu = () => {
		setIsExpanded((isExpanded) => !isExpanded);
	};

	return (
		<>
			<nav id="main-menu">
				<div className="main-menu-wrapper">
					<div id="logo">
						<a className="logo" href="https://graphweaver.com">
							<img src="/img/graphweaver-logo.svg" alt="Graphweaver logo" height="25" />
						</a>
					</div>

					<ul className="main-menu-list">{menuItems}</ul>

					<div
						id="toggle-menu-btn"
						className={!isExpanded ? 'btn-closed' : 'open'}
						onClick={toggleMenu}
					>
						<span></span>
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>

				<ul className={`mobile-menu-list ${!isExpanded ? 'closed' : 'open'}`}>{menuItems}</ul>
			</nav>
		</>
	);
};
